import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";

const TITLE = "Calculatrice de fréquence cardiaque pendant l'exercice";
const DESCRIPTION =
  "Calculatrice de fréquence cardiaque pendant l en francais pour estimer vos indicateurs de sante rapidement. Entrez vos donnees et obtenez un resultat clair avec des reperes utiles pour le suivi quotidien.";
const KEYWORDS =
  "de fréquence cardiaque pendant l, calculatrice de fréquence cardiaque pendant l, calcul en ligne, sante, bien-etre, indicateurs sante, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/heartbeat-calculator/";

function HeartbeatCalculator() {
  const [age, setAge] = useState("");
  const [intensity, setIntensity] = useState(50);
  const [result, setResult] = useState();
  const [error, setError] = useState("");

  const handleCalculate = () => {
    try {
      if (age && intensity >= 0 && intensity <= 100) {
        const maxHeartRate = 220 - parseInt(age);
        const targetHeartRate = Math.round((maxHeartRate * intensity) / 100);
        const lowerBound = Math.round(maxHeartRate * 0.5);
        const upperBound = Math.round(maxHeartRate * 0.85);

        setResult({
          targetHeartRate,
          lowerBound,
          upperBound,
        });
      } else {
        throw new Error("Veuillez entrer toutes les valeurs correctement.");
      }
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Cette calculatrice calcule la fréquence cardiaque idéale pendant l'exercice.
                </p>
                <p>Pour calculer le résultat, veuillez entrer votre âge et l'intensité de l'exercice.</p>
                <p>
                  Pour calculer la fréquence cardiaque cible, vous devez d'abord déterminer votre fréquence cardiaque maximale. Vous pouvez calculer ce taux en utilisant l'une des deux méthodes courantes suivantes:
                </p>
                <ul>
                  <li>Fréquence cardiaque maximale = 220 - âge de la personne en années</li>
                  <li>
                    Fréquence cardiaque maximale = 206,9 - (0,67 × âge de la personne en années)
                  </li>
                </ul>
                La première méthode est plus facile que la seconde, mais la seconde est plus précise.
                <div>
                  <br />
                </div>
                <p>
                  La plage idéale de fréquence cardiaque pendant l'exercice dépend de l'intensité de l'exercice. Voici quelques plages suggérées:
                </p>
                <ul>
                  <li>Exercice léger: 57% - 63%</li>
                  <li>Exercice modéré: 64% - 76%</li>
                  <li>Exercice aérobie: 70% - 80%</li>
                  <li>Exercice intense: 77% - 95%</li>
                  <li>Exercice maximal: 96% - 100%</li>
                </ul>
                <p>
                  Cette calculatrice a été développée en fonction de{" "}
                  <a
                    href="https://www.heartonline.org.au/resources/calculators/target-heart-rate-calculator"
                    rel="nofollow"
                  >
                    la Fondation cardiaque nationale en Australie
                  </a>
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="ltr">
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="age">
                        Entrez votre âge
                      </label>
                      <input
                        id="age"
                        type="number"
                        value={age}
                        onChange={(e) => setAge(e.target.value)}
                        placeholder="Entrez votre âge"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="intensity">
                        Choisissez l'intensité de l'exercice
                      </label>
                      <select
                        id="intensity"
                        value={intensity}
                        onChange={(e) => setIntensity(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      >
                        {[...Array(101).keys()].map((value) => (
                          <option key={value} value={value}>
                            {value}%
                          </option>
                        ))}
                      </select>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      Calculer
                    </button>
                  </div>
                  <br />
                  {error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Erreur: {error}
                    </p>
                  )}
                  {result && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Résultats:</h4>
                      <p className="text-white">Fréquence cardiaque cible: {result.targetHeartRate} bpm</p>
                      <p className="text-white">Limite inférieure: {result.lowerBound} bpm</p>
                      <p className="text-white">Limite supérieure: {result.upperBound} bpm</p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
  <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Conseils d'utilisation</h3></div>
              <div className="info-section-body">
                <p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>La frquence cardiaque</h3></div>
              <div className="info-section-body"><p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p></div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Frquence cardiaque maximale</h3></div>
              <div className="info-section-body"><p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeartbeatCalculator;
